import {
    Scene,
    OrthographicCamera,
    WebGLRenderer,
    PlaneGeometry,
    Mesh,
    ShaderMaterial,
    Vector2,
} from 'three';
import quadVertexShader from './quad.vert';
import quadFragmentShader from './quad.frag';

// Create the scene
const scene = new Scene();

// Create the orthographic camera
const camera = new OrthographicCamera(
    -1,
    1,
    1,
    -1
);
camera.position.z = 1;

// Create the renderer
const renderer = new WebGLRenderer({
    preserveDrawingBuffer: true // Note slow, but allows saving
});
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild(renderer.domElement);


// Create the shader material
const material = new ShaderMaterial({
    uniforms: {
        time: { value: 0.0 },
        resolution: { value: new Vector2(window.innerWidth, window.innerHeight) },
    },
    vertexShader: quadVertexShader,
    fragmentShader: quadFragmentShader,
});

// Create the mesh
var mesh = new Mesh(new PlaneGeometry(2, 2), material);
scene.add(mesh);

// Function to handle window resize
function onWindowResize() {
    camera.left = window.innerWidth / -2;
    camera.right = window.innerWidth / 2;
    camera.top = window.innerHeight / 2;
    camera.bottom = window.innerHeight / -2;
    camera.updateProjectionMatrix();

    renderer.setSize(window.innerWidth, window.innerHeight);

    material.uniforms.resolution.value.set(window.innerWidth, window.innerHeight);
}

// Add event listener for window resize
window.addEventListener('resize', onWindowResize, false);



// Add event listener for save command
window.addEventListener('keydown', (event) => {
    if (event.key === 's') {
        event.preventDefault();
        downloadImage();
    }

    if (event.key === 'f' || event.key === 'F') {
        toggleFullScreen();
    }
});

// Function to download the image
function downloadImage() {
    const link = document.createElement('a');
    const timestamp = Date.now();
    const filename = `preview-${document.title}-${timestamp}.png`;
    link.href = renderer.domElement.toDataURL('image/png');
    link.download = filename;
    link.click();
}

function toggleFullScreen() {
    if (!document.fullscreenElement) {
        // Request fullscreen mode
        document.documentElement.requestFullscreen().catch(err => {
            console.error(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
        });
    } else {
        // Exit fullscreen mode
        if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }
}

console.log('Press `s` to download image');

// Animation loop
function animate(time) {
    requestAnimationFrame(animate);
    material.uniforms.time.value = time;
    renderer.render(scene, camera);
}

animate();
